import { render, staticRenderFns } from "./EditTraining.vue?vue&type=template&id=65eb3f4d&scoped=true&"
import script from "./EditTraining.vue?vue&type=script&lang=js&"
export * from "./EditTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb3f4d",
  null
  
)

export default component.exports